import { BillingTier } from "types/generated";

export const TIER_PLANS_LABELS = {
  [BillingTier.Free]: "Free",
  [BillingTier.Cloud]: "Cloud",
  [BillingTier.Enterprise]: "Enterprise SaaS",
  [BillingTier.V3Free]: "Free",
  [BillingTier.V3Cloud]: "Cloud",
  [BillingTier.V4Free]: "Free",
  [BillingTier.V4Starter]: "Starter",
  [BillingTier.V4StarterPlus]: "Starter +",
  [BillingTier.V4Business]: "Business",
  [BillingTier.V4Enterprise]: "Enterprise",
  [BillingTier.V5Free]: "Free",
  [BillingTier.V5Starter]: "Starter",
  [BillingTier.V5StarterPlus]: "Starter +",
  [BillingTier.V5StarterPlus_2]: "Starter +",
  [BillingTier.V5Business]: "Business",
  [BillingTier.V5Enterprise]: "Enterprise",
  [BillingTier.V5EnterprisePlus]: "Self-Hosted",
  [BillingTier.V5Strategic]: "Strategic",
};
